import { BookingParty, IQuoteServices } from 'features/BookingFlow'
import { ILegalEntityJSON, ILocationModelJSON } from 'features/Directory'
import { TTransportMode, TTransportType } from 'features/TransportPlan'
import { ISO } from 'service/ISO'

import { PointJSON } from './Point'

export enum BookingFlowEnum {
  Direct = 'DIRECT',
  Approval = 'APPROVAL',
  ConditionalApproval = 'CONDITIONAL_APPROVAL',
}

export interface IBookingTemplate {
  _id: string
  customerId: string
  userId: string
  name: string
  type: TTransportType
  journey: {
    origin: PointJSON
    destination: PointJSON
  }
  originLocationId?: string
  destinationLocationId?: string
  modes: TTransportMode[]
  services: IQuoteServices
  isDemo: boolean
  legalEntity: ILegalEntityJSON
  editable: boolean
  flow: BookingFlowEnum
  bookingParty?: BookingParty
  incoTerm?: ISO.IncoTermsCode
  assignedUsers: string[]
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date
  lastUsedAt?: Date
}

export type CreateBookingTemplate = Omit<
  IBookingTemplate,
  '_id' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'lastUsedAt'
>

export type UpdateBookingTemplate = Omit<
  IBookingTemplate,
  '_id' | 'userId' | 'customerId' | 'createdAt' | 'updatedAt' | 'deletedAt'
>

export interface IBookingTemplateWithLocation extends IBookingTemplate {
  originLocation?: ILocationModelJSON
  destinationLocation?: ILocationModelJSON
}
